import { ClientTrackingCategory } from '@models/client-tracking-category';
import { ClientTrackingName } from '@models/client-tracking-name';
import { OnboardingDetailsRequestEvent } from '@models/onboarding-review/onboarding-details-request-event';
import { IRemoteRepresentativeService } from '@services/remote-representative-service';
import TrackingService, { ITrackingService } from '@services/TrackingService';
import {
    Observable,
    Subject
} from 'rxjs';

export interface IOnboardingDetailsRequestService {
    /**
     * Temporary place to put events
     */
    readonly requestEvents: Observable<OnboardingDetailsRequestEvent>;

    /**
     * Triggers a request to load the data for an employee's onboarding I-9 details
     */
    triggerRequest(): Promise<void>;
}

export enum OnboardingDetailsRequestServiceErrors {
    MissingRequiredFields = 'Missing required fields from I-9 details'
}

export class OnboardingDetailsRequestService implements IOnboardingDetailsRequestService {
    private requestEventsSubject = new Subject<OnboardingDetailsRequestEvent>();
    private readonly trackingService: ITrackingService;
    constructor(
        private remoteRepresentativeService: IRemoteRepresentativeService
    ) {
        this.trackingService = new TrackingService();
    }

    get requestEvents(): Observable<OnboardingDetailsRequestEvent> {
        return this.requestEventsSubject;
    }

    async triggerRequest(): Promise<void> {
        this.requestEventsSubject.next({
            type: 'pending'
        });

        try {
            const response = await this.remoteRepresentativeService.getRemoteI9DetailsAsync();
            if (!response.section2Details || !response.candidateDetails || !response.translatorDetails) {
                throw new Error(OnboardingDetailsRequestServiceErrors.MissingRequiredFields);
            }

            const documentTypes = response.documentDetails.map((item) => item.documentType);
            const request = { documentTypes, includeDisabled: true };
            const documentTypesResponse =
              await this.remoteRepresentativeService.getDocumentTypes(
                request
              );

            const workerStatus = await this.remoteRepresentativeService.getStatusAsync();
            
            this.requestEventsSubject.next({
                type: 'success',
                dto: response
            });
            this.requestEventsSubject.next({type: 'workerStatusSuccess', dto: workerStatus?.i9Section2Status ?? ''});
              this.trackingService.trackEvent(ClientTrackingCategory.DocumentTypes, ClientTrackingName.Success);
            this.requestEventsSubject.next({
                type: 'documentTypesSuccess',
                dto: documentTypesResponse
            });
        } catch (error: unknown) {
            this.trackingService.trackEvent(ClientTrackingCategory.DocumentTypes, ClientTrackingName.Error);
            this.requestEventsSubject.next({
                error: error as Error,
                type: 'error'
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/services/onboarding-review/onboarding-details-request-service.ts